/*
 * @Author: bbqin
 * @Date: 2022-10-20 13:35:55
 * @LastEditTime: 2023-04-15 15:46:29
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\libs\dnd\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from 'react';
import { DragDropContext, DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Container from './container';
// import withDragDropContext from '../../../../WithDragDropContext';
import { DndDropContext } from '@platform/base';

require('./index.less');
// @withDragDropContext

class ReactDnd extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        // return <DragDropContextProvider backend={HTML5Backend} window={window} key="1" >
        //     <Container {...this.props} />
        // </DragDropContextProvider>;
        return <Container {...this.props} />;
    }
}

export default DndDropContext(ReactDnd);